export default "__VITE_PUBLIC_ASSET__0e76cb8f__"